<script setup lang="ts">
    import Logotype from '../Logotype.vue';
    import UserAvatar from '../UserAvatar.vue';

    defineProps({
        role: {
            type: String,
            required: true,
        },
    });
</script>

<template>
    <UserAvatar
        v-if="role === 'user'"
        :label="$userInfo?.name || $userInfo?.email"
        size="md"
        color="plum"
    ></UserAvatar>
    <UserAvatar v-else size="md" color="raspberry">
        <Logotype :symbol-only="true" height="h-4" />
    </UserAvatar>
</template>
